import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { DashboardDynamicBanner } from './useDynamicBanner.types';

interface DashboardDynamicBannerContextType {
  banner: DashboardDynamicBanner | null;
  showBanner: (banner: DashboardDynamicBanner) => void;
  hideBanner: () => void;
}

export const DashboardDynamicBannerContext = createContext<DashboardDynamicBannerContextType>({
  banner: null,
  showBanner: () => {},
  hideBanner: () => {},
});

/** `initialBanner`: shown from the first render, so a server render can carry it (PRNT-5494). */
export const useDynamicBannerState = (initialBanner?: DashboardDynamicBanner) => {
  const [banner, setBanner] = useState<DashboardDynamicBanner | null>(initialBanner ?? null);

  const showBanner = useCallback((banner: DashboardDynamicBanner) => {
    setBanner(banner);
  }, []);

  const hideBanner = useCallback(() => {
    setBanner(null);
  }, []);

  return useMemo(() => ({ banner, showBanner, hideBanner }), [banner, showBanner, hideBanner]);
};

export const useDynamicBanner = () => {
  return useContext(DashboardDynamicBannerContext);
};
